/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import { useState, useEffect, useRef } from 'react';
import { QueryBuilder } from 'react-querybuilder';


import useStateRef from "react-usestateref";

import { Icon as Iconify } from '@iconify/react';
import 'react-querybuilder/dist/query-builder.css';

import '../Others/QueryBuilderStyles.css';
import { useLocation } from 'react-router';

import { FormProvider } from 'react-hook-form';

import { ClearIcon } from '@mui/x-date-pickers';
import { Select, MenuItem, Button, Tooltip, IconButton, Checkbox, TextField, Autocomplete, Box, Stack, FormControl, FormControlLabel, Paper, Divider } from '@mui/material';
import schemedefinationService from '../../../services/schemedefination.service';


import ItemValueEditor from '../Others/ItemQueryBuilderValueEditor';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import { useSchemeStore } from '../schemeStore';
import { useSchemeSavePermission } from '../utils/useSchemeSavePermission';




const custom = ({
    contributionItems = [],
    inputValue = '',
    selectedContributionItems = [],
    setSelectedContributionItems,
    ...props
}) => {   // NOSONAR

    const filteredOptions = contributionItems.filter(item =>
        item?.Item?.toLowerCase().includes(inputValue.toLowerCase())
    );

    const isAllFilteredSelected = selectedContributionItems?.length > 0 && filteredOptions.every(option =>
        selectedContributionItems.some(selected => selected.ItemId === option.ItemId)
    );

    return (
        <Paper {...props}>
            <Box
                onMouseDown={(e) => e.preventDefault()}
                sx={{ display: 'flex', height: '2rem', alignItems: 'center', paddingLeft: '2.142em' }}
            >
                <FormControlLabel
                    onClick={(e) => {
                        e.preventDefault();
                        if (inputValue.length > 0) {
                            if (isAllFilteredSelected) {
                                // Unselect filtered options
                                const newSelectedValues = selectedContributionItems.filter(item =>
                                    !filteredOptions.some(filtered => filtered.ItemId === item.ItemId)
                                );
                                setSelectedContributionItems(newSelectedValues);
                            } else {
                                // Select filtered options
                                const newSelectedValues = Array.from(new Set([...selectedContributionItems, ...filteredOptions]));
                                setSelectedContributionItems(newSelectedValues);
                            }
                        } else if (selectedContributionItems.length < contributionItems.length) {
                            setSelectedContributionItems(contributionItems);
                        } else {
                            setSelectedContributionItems([]);
                        }
                    }}
                    label={
                        <span style={{ fontSize: '13px' }}>
                            {inputValue.length > 0
                                ? isAllFilteredSelected   // NOSONAR
                                    ? 'Unselect filtered options'
                                    : 'Select filtered options'
                                : selectedContributionItems?.length === contributionItems?.length && selectedContributionItems?.length > 0 // NOSONAR
                                    ? 'Unselect All'
                                    : 'Select All'}
                        </span>
                    }
                    control={
                        <Checkbox
                            size='small'
                            id="select-all-checkbox"
                            checked={
                                contributionItems?.length > 0 && inputValue?.length > 0
                                    ? isAllFilteredSelected
                                    : contributionItems?.length > 0 &&
                                    selectedContributionItems?.length === contributionItems?.length
                            }
                        />
                    }
                />
            </Box>
            <Divider />
            {props?.children}
        </Paper>
    );
};


const SchemeItem = () => {  // NOSONAR

    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;
    const canSaveScheme = useSchemeSavePermission(isCopyScheme);
    const {
        schemeDetails,
        parentSchemeDetails,
        schemeData,
        updateScheme,
        tabValue,
        prevTabValue,
        setItemData,
        setContributionItemData,
        addScheme,
    } = useSchemeStore();


    const newSchemeDefinitionData = parentSchemeDetails || schemeDetails;




    const initialLoading = useRef(true);

    const [classificationData, setClassificationData] = useState(null);
    const [subClassificationData, setSubClassificationData] = useState({});
    const [classification, setClassification] = useState(null);
    const [selectedClassification, setSelectedClassification] = useState(null);


    const [dataTypes, setDataTypes] = useState({});  // NOSONAR
    const [errorMessage, setErrorMessage] = useState(null);
    const [searchedValue, setSearchedValue] = useState('');  // NOSONAR


    const [alertType, setAlertType] = useState(''); // NOSONAR
    const [alertMessage, setAlertMessage] = useState(''); // NOSONAR
    const [showAlert, setShowAlert] = useState(false); // NOSONAR



    const [loadingCount, setLoadingCount] = useState(0);
    const showLoading = () => setLoadingCount((prev) => prev + 1);
    const hideLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));




    const [initialQuery, setInitialQuery, initialQueryRef] = useStateRef(null);


    useEffect(() => {
        const fetchData = async () => {

            showLoading()

            try {
                const itemData = newSchemeDefinitionData.Item;

                // Extract unique subclassification names
                const subclassifications = new Set(
                    itemData
                        .flatMap((filterData) => filterData.Details)
                        .flatMap((detail) =>
                            Object.keys(detail)
                                .filter((key) => key !== 'ConditionalStatement')
                                .map((key) => key.split('-').pop())
                        )
                );

                // Fetch data for each subclassification concurrently
                const subclassificationPromises = Array.from(
                    subclassifications
                ).map(async (item) => {
                    const payload = {
                        filterApplicationOn: 'Item',
                        filterClassification: item,
                        IsException: false,
                        SchemeId: 0,
                    };

                    const schemeDefinationInstance = await schemedefinationService;
                    const response = await schemeDefinationInstance.GetSchemeFilterSubClassificationItem(
                        payload
                    );

                    if (response.status === 200) {
                        return { [item]: response.data };
                    }

                    console.error(
                        'Error while fetching subclassification data. Status:',
                        response.status,
                        'Error Message:',
                        response.data
                    );
                    return null;

                });

                const subclassificationResponses = await Promise.all(
                    subclassificationPromises
                );

                // Process and merge subclassification data
                const newSubClassificationData = {};
                const newDataTypes = {};

                subclassificationResponses.forEach((response) => {
                    if (response) {
                        Object.entries(response).forEach(([key, value]) => {
                            newSubClassificationData[key] = value?.DefaultValues || [];
                            newDataTypes[key] = value?.DataType || '';
                        });
                    }
                });


                setSubClassificationData(newSubClassificationData);
                setDataTypes(newDataTypes);

                // ... Your logic for transforming itemData to QueryBuilder structure ...

                let queryBuilderStructure;

                if (itemData.length > 0) {
                    queryBuilderStructure = transformItemDataToQueryBuilder(itemData[0]?.Details);
                } else {
                    return;
                }

                setInitialQuery(queryBuilderStructure);
                setGeneratedQuery(queryBuilderStructure);
            } catch (error) {
                console.error('Error:', error);
            } finally {

                hideLoading()
                // setLoading(false)
            }
        };

        fetchData();


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newSchemeDefinitionData]);


    const transformItemDataToQueryBuilder = (data) => { // NOSONAR
        const cdn = data[0]?.ConditionalStatement;

        const extractFieldDetails = (field) => {
            const match = field.match(/(\d+)!([A-Za-z]+):([A-Za-z0-9\-_]+)/);  // NOSONAR
            if (!match) {
                return null;
            }
            const [, index, operator, fieldName] = match;
            return { index, operator, fieldName };
        };

        const buildRule = (fieldIndex, operator, fieldData) => {
            const rule = {
                field: fieldIndex,
                operator: operator === "NotIN" ? "NotIN" : operator,
                valueSource: "value",
                value: fieldData,
            };
            return rule;
        };

        const parseCondition = (condition) => {
            // Adjusted regex to ignore empty tokens
            const tokens = condition.match(/\S+/g); // Matches non-whitespace sequences
            let index = 0;

            const parseExpression = () => {
                const rules = [];
                let combinator = 'and';

                while (index < tokens.length) {
                    const token = tokens[index];

                    if (token === ')') {
                        index += 1;
                        break;
                    } else if (token === '(') {
                        index += 1;
                        const subExpression = parseExpression();
                        rules.push(subExpression); // Save the parsed sub-expression
                    } else if (token === 'AND' || token === 'OR') {
                        combinator = token.toLowerCase();
                        index += 1;
                    } else {
                        const fieldDetails = extractFieldDetails(token);
                        if (fieldDetails) {
                            const { index: fieldIndex, operator, fieldName } = fieldDetails;
                            const fieldData = data[0][`${fieldIndex}!${fieldName}`];

                            const rule = buildRule(fieldName, operator, fieldData);
                            rules.push(rule);
                        }
                        index += 1;
                    }
                }

                const expression = { combinator, rules };
                return expression;
            };

            return parseExpression();
        };

        return parseCondition(cdn).rules[0];
    };

    // Fetch classifications on mount

    useEffect(() => {


        const getClassification = async () => {
            // setLoading(true)
            //  showLoading()
            try {

                showLoading()
                const schemeDefinationInstance = await schemedefinationService;
                const response = await schemeDefinationInstance.Item();

                if (response.status === 200) {
                    setClassificationData(response.data);
                    setClassification(
                        response.data[0].DefaultValues?.map((item) => ({
                            name: item.SchemeFilterClassification,
                            label: item.SchemeFilterClassification,
                        }))
                    );

                    hideLoading()
                } else {
                    console.error(
                        'Error while fetching classification data. Status: ',
                        response.status,
                        'Error Message:',
                        response.data
                    );
                }

                // hideLoading()

            } catch (error) {

                hideLoading()
                console.error('Error:', error);
            } finally {

                //  hideLoading()
                initialLoading.current = false;
            }
        };

        getClassification();
    }, []);

    // Fetch subclassifications when selectedClassification changes

    const operators = [
        { name: 'IN', label: 'IN' },
        { name: 'NotIN', label: 'Not IN' },
    ];

    const fields = classification?.map((item) => ({
        name: `${classificationData[0]?.TableName}-${item.label}`,
        label: item.label,
    }));

    const operatorOptions = operators.map((op) => ({
        name: op.name,
        label: op.label,
    }));


    const getUsedFieldsInGroup = (rules) => {
        const used = new Set();
        if (Array.isArray(rules)) {
            rules.forEach(rule => {
                if (rule && rule.field) {
                    used.add(rule.field);
                }
            });
        }
        return used;
    };

    const onAddRule = (rg, parentPath) => {
        const newQuery = JSON.parse(JSON.stringify(initialQuery));

        let targetGroup = newQuery;
        parentPath.forEach(idx => {
            targetGroup = targetGroup.rules[idx];
        });

        // Get available fields for THIS GROUP
        const usedFields = getUsedFieldsInGroup(targetGroup.rules);
        const availableFields = fields.filter(f => !usedFields.has(f.name));

        // Use first available field or fallback to first field
        const newField = availableFields[0]?.name || fields[0].name;


        const newRule = {
            field: newField,
            operator: operators?.[0]?.name || 'IN',
            value: newField === 'accountValue' ? 0 : '' // Default values
        };

        targetGroup.rules = [...targetGroup.rules, newRule];
        handleQueryChange(newQuery);
    };


    const combinators = [
        { name: 'and', label: 'AND' },
        { name: 'or', label: 'OR' },
    ];

    const [generatedQuery, setGeneratedQuery] = useState({});

    const handleQueryChange = (newQuery) => {
        setInitialQuery(newQuery);
        setGeneratedQuery(newQuery);
    };


    const newQueryFormat = (query) => { // NOSONAR

        const result = {};
        let conditionalStatement = "";
        let counter = 1;
        const fieldValues = {};
        let errMsg = null;

        function processRules(rules, parentCombinator = null) {
            let localStatement = "";
            rules.forEach((rule, index) => {
                if (rule.rules) {
                    const nestedStatement = processRules(rule.rules, rule.combinator);
                    localStatement += `( ${nestedStatement} )`;
                } else {
                    const key = `${counter}!${rule.field}`;

                    if (
                        !Array.isArray(rule?.value) ||
                        (Array.isArray(rule?.value) && (rule?.value.length === 0 || rule?.value[0] === ''))
                    ) {

                        setErrorMessage("Please select values in all rules!");
                        setItemData("error");
                        throw new Error("Please select values in all rules!");

                        // return;
                    }
                    result[key] = rule.value.map(item => {
                        if (typeof item === 'string') {
                            return item;
                        } if (typeof item === 'object' && item !== null) {  // NOSONAR
                            const keyWithId = Object.keys(item).find(keyy => keyy.toLowerCase().includes("id"));
                            return keyWithId ? item[keyWithId] : null;
                        }
                        return null;
                    }).filter(item => item !== null);








                    localStatement += `${counter}!${rule.operator}:${rule.field}`;

                    // Store the values for each field and operator
                    if (!fieldValues[rule.field]) {
                        fieldValues[rule.field] = { IN: [], NotIN: [] };
                    }
                    fieldValues[rule.field][rule.operator] = fieldValues[rule.field][rule.operator].concat(rule.value);

                    counter += 1;
                }

                if (index < rules.length - 1) {
                    localStatement += ` ${(parentCombinator || query.combinator).toUpperCase()} `;
                }
            });
            return localStatement;
        }

        conditionalStatement = processRules(query.rules);

        if (query.not) {
            conditionalStatement = `NOT ( ${conditionalStatement} )`;
        }

        result.ConditionalStatement = `( ${conditionalStatement} )`;
         //  console.log("FieldValues: ", fieldValues);
        // Validate for conflicting conditions
        Object.entries(fieldValues).forEach(([field, operatorValues]) => {
            const inValues = new Set(operatorValues.IN);
            const notInValues = new Set(operatorValues.NotIN);
            const conflictingValues = [...inValues].filter(x => notInValues.has(x));
            if (conflictingValues.length > 0) {
                 //  console.log("subClassificationData: ", subClassificationData);
                 //  console.log("selectedClassification: ", selectedClassification);
                 //  console.log("subClassificationData[selectedClassification]: ", subClassificationData[selectedClassification]);
                errMsg = `Same item(s) selected for ${field.split('-').pop()} in IN and NOT IN:  ${conflictingValues.map(value => {
                    const matchingItem = subClassificationData[selectedClassification].find(item => Object.values(item).includes(value));
                    if (matchingItem) {
                        const nameKey = Object.keys(matchingItem).find(key => !key.toLowerCase().includes("id"));
                        return matchingItem[nameKey] || value;
                    }
                    return value;
                }).join(', ')}`;

            }
        });

        // Iterate over all values in the result object
        const values = Object.values(result);
        const hasEmptyValue = values.some(value => (Array.isArray(value) && value.length === 0) || value === '');

        // If the result object has exactly two key-value pairs and one of them is empty, return []
        if (values.length === 2 && hasEmptyValue) {
            return [];
        }




            if (result.ConditionalStatement === '(  )') {
            return [];
        }
    
        // If no conditions, return an empty array
        if (result?.ConditionalStatement.length === 0) {
            return [];
        }

        const emptyFields = Object.entries(result).filter(([key, value]) => value === "").map(([key]) => key.split("!").pop());
        if (emptyFields.length > 0) {

            errMsg = `Please select values in all rules!`;
            setErrorMessage(errMsg);
            return ['error', errMsg];
        }


        if (errMsg) {
            setErrorMessage(errMsg);
            return ['error', errMsg];
        }

        if (!errMsg) {
            setErrorMessage(null);
        }


        function hasEmptyParentheses(statement) {
            // ( )
            if (/^\(\s*\)$/.test(statement)) {
                return false;
            }



            // Step 1: First, remove all parentheses that contain non-whitespace content
            const contentParenthesesRegex = /\([^()]*[^()\s][^()]*\)/g;  // NOSONAR
            let reducedStatement = statement;

            while (contentParenthesesRegex.test(reducedStatement)) {
                reducedStatement = reducedStatement.replace(contentParenthesesRegex, '');
            }

            // Step 2: Now check if any parentheses are left that are empty or contain only spaces
            const emptyParenthesesRegex = /\(\s*\)/;
            return emptyParenthesesRegex.test(reducedStatement);
        };


        if (hasEmptyParentheses(result.ConditionalStatement)) {
            setErrorMessage("Please remove empty rulegroups or add rules in the rulegroups!");
            errMsg = "Please remove empty rulegroups or add rules in the rulegroups!";
            return ['error', errMsg];
        }

        return [result];
    };



    const isDisabled = parentSchemeDetails || newSchemeDefinitionData?.SchemeData?.ParentschemeId;

    const disabledStyle = {
        pointerEvents: 'none',
        opacity: 0.5,
    };

    const [contributionItems, setContributionItems] = useState([]);
    const [selectedContributionItems, setSelectedContributionItems] = useState([]);
    const [isContributionItemsVisible, setIsContributionItemsVisible] = useState(schemeDetails?.ContributionItem?.length > 0);


    useEffect(() => {
        if (!isContributionItemsVisible) {
            setIsContributionItemsVisible(schemeDetails?.ContributionItem?.length > 0);
        }
    }, [schemeDetails, isContributionItemsVisible]);

    const [inputValue, setInputValue] = useState('');  // State to store the input value
    const [debounceTimeout, setDebounceTimeout] = useState(null);  // State to store the timeout ID



    const handleAdditionalRebate = async (searchText) => {
        const searchedText = searchText;
        setIsContributionItemsVisible(true);
        const details = newQueryFormat(generatedQuery);
        if (details[0] === 'error') {
            console.warn(details[1]);



            return;
        }


        let Item;

        if (Array.isArray(details) && details.length > 0) {
            Item = {
                FilterType: "Item",
                Details: details,
            };
        }
        const payload = {
            "Filters": [
                Item
            ],
            "SearchText": searchedText || ''
        }

        showLoading()
        try {
            const schemeDefinationInstance = await schemedefinationService;
            const response = await schemeDefinationInstance.GetContributionItems(
                payload
            );




            setContributionItems(prevItems => {
                // Merge previous items with new items, ensuring unique ItemId values
                const uniqueItems = [...prevItems, ...response.data].filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.ItemId === value.ItemId
                    ))
                );
                return uniqueItems;
            });



        } catch (err) {
             //  console.log('err', err)
        } finally {
            //  setLoading(false)
            hideLoading()
        }
    }
    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);  // Update the input value immediately

        // If there's a previous debounce timeout, clear it
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Set a new timeout for the API call
        const newTimeout = setTimeout(() => {
            if (newInputValue.length > 2) {  // Call API only if input length > 2
                // fetchData(newInputValue);
                handleAdditionalRebate(newInputValue)// Call your function to fetch data
            }
        }, 500);  // Set delay to 500ms (this can be adjusted)

        setDebounceTimeout(newTimeout);  // Store the new timeout ID
    };
    useEffect(() => { // NOSONAR
        const loadInitialContributionItems = async () => {

            // setLoading(true)
            showLoading();
            try {


                const itemData = schemeDetails.Item;
                let queryBuilderStructure = null;
                let details = null

                if (itemData != null && itemData?.length > 0) {
                    queryBuilderStructure = transformItemDataToQueryBuilder(itemData[0]?.Details);
                    details = newQueryFormat(queryBuilderStructure);
                }
                if (details != null && details[0] === 'error') {
                    console.warn(details[1]);

                    return;
                }

                const emptyArr = [];

                let Item;

                if (details != null && details !== emptyArr) {
                    Item = {
                        FilterType: "Item",
                        Details: details,
                    };
                } else {
                    Item = {
                        FilterType: "Item",

                    };
                }

                const payload = {
                    "Filters": [
                        Item
                    ]
                }



                const schemeDefinationInstance = await schemedefinationService;
                const response = await schemeDefinationInstance.GetContributionItems(
                    payload
                );


                if (response.status === 200) {
                    setContributionItems(response.data);

                    // Pre-select the existing contribution items in the Autocomplete
                    const preSelectedItems = response.data.filter(item =>
                        schemeDetails.ContributionItem[0].ItemId.includes(item.ItemId)
                    );
                    setSelectedContributionItems(preSelectedItems);
                } else {
                    console.error('Error fetching contribution items:', response.data);
                }
            } catch (error) {
                console.error('Error loading initial contribution items:', error);
            } finally {

                hideLoading()
                //  setLoading(false)

            }
        };

        if (schemeDetails?.ContributionItem?.length > 0) {
            loadInitialContributionItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails]);


    const initialValue = classificationData?.[0].DefaultValues[0].SchemeFilterClassification;
    const tableName = classificationData?.[0]?.TableName;


    useEffect(() => {
         //  console.log("INITIAL QUERY: ", initialQuery);
    }, [initialQuery]);
    useEffect(() => {

         //  console.log("INITIAL VALUES: ", initialValue, tableName);
         //  console.log("TRUE FALSE: ", initialValue && tableName && !initialQuery.rules.length > 0);
        if (initialValue && tableName && !initialQuery.rules.length > 0) {
            setSelectedClassification(initialValue || null);
            setInitialQuery({
                "combinator": "and",
                "rules": [
                    {
                        "field": `${tableName}-${initialValue}`,
                        "operator": "IN",
                        "valueSource": "value",
                        "value": null
                    }
                ]
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classificationData]);

    useEffect(() => {
        if (schemeData?.AdditionalRebate) {
            setSelectedContributionItems([]);
            setIsContributionItemsVisible(false);
            setContributionItems([]);
        }
    }, [schemeData?.AdditionalRebate]);


    useEffect(() => {
        if (prevTabValue.name === 'Item') {
            formDataSave();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const formDataSave = async () => {

        try {
            let itemData;
            let contributionItemData;
             //  console.log(itemData);
             //  console.log(contributionItemData);
            const details = newQueryFormat(generatedQuery);
            if (details[0] === 'error') {

                itemData = 'error'; // NOSONAR

                // hideLoading()

                return;
            }
            if (Array.isArray(details) && details.length > 0) {
                const vals = Object.values(details[0])[0];
                if (!vals.length > 0) {
                    setErrorMessage("Please select at least one value");

                    itemData = 'error'; // NOSONAR


                    return;
                }
            }


            let Item = null;

            if (Array.isArray(details) && details.length > 0) {
                Item = {
                    FilterType: "Item",
                    Details: details,
                };
            }

            const payload = newSchemeDefinitionData;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;



            if (Array.isArray(details) && details.length > 0) {
                payload.Item = Item;

                itemData = Item;

            } else {

                itemData = null;


            }

            if (selectedContributionItems.length > 0) {
                contributionItemData = [ // NOSONAR
                    {
                        ItemId: selectedContributionItems.map(item => item.ItemId) // Assuming ItemId is the correct property
                    }
                ];

                payload.SchemeData.AdditionalRebate = schemeData?.AdditionalRebate;



                contributionItemData = [
                    {
                        ItemId: selectedContributionItems.map(item => item.ItemId) // Assuming ItemId is the correct property
                    }
                ]

            }


            setItemData(itemData);
            setContributionItemData(contributionItemData)

            // hideLoading()

        } catch (err) {


             //  console.log("Err: ", err);
        }

    }


    async function saveData() {



        try {
            let itemData;
            let contributionItemData;
             //  console.log(itemData);
             //  console.log(contributionItemData);
            const details = newQueryFormat(generatedQuery);
            if (details[0] === 'error') {

                itemData = 'error'; // NOSONAR

                // hideLoading()

                return;
            }
            if (Array.isArray(details) && details.length > 0) {
                const vals = Object.values(details[0])[0];
                if (!vals.length > 0) {
                    setErrorMessage("Please select at least one value");

                    itemData = 'error'; // NOSONAR


                    return;
                }
            }


            let Item = null;

            if (Array.isArray(details) && details.length > 0) {
                Item = {
                    FilterType: "Item",
                    Details: details,
                };
            }

            const payload = newSchemeDefinitionData;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;



            if (Array.isArray(details) && details.length > 0) {
                payload.Item = Item;

                itemData = Item;

            } else {

                itemData = null;


            }

            if (selectedContributionItems.length > 0) {
                contributionItemData = [ // NOSONAR
                    {
                        ItemId: selectedContributionItems.map(item => item.ItemId) // Assuming ItemId is the correct property
                    }
                ];

                payload.SchemeData.AdditionalRebate = schemeData?.AdditionalRebate;



                contributionItemData = [
                    {
                        ItemId: selectedContributionItems.map(item => item.ItemId) // Assuming ItemId is the correct property
                    }
                ];

            }

             //  console.log('itemData: ', itemData);
            setItemData(itemData);
            setContributionItemData(contributionItemData);
            try {
                if (isCopyScheme) {
                    const result = await addScheme(); // NOSONAR
                } else {

                    const result = await updateScheme(); // NOSONAR
                }
            } catch (err) {
                // handle error
            }

            // hideLoading()

        } catch (err) {


             //  console.log("Err: ", err);
        }



    }



    return (

        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%', // Make sure parent takes full height
        }}>
            <FormProvider >
                <div

                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        minHeight: 0, // Enables child to grow correctly inside a flex container
                    }}
                >
                    {/* Scrollable content */}
                    <div style={{
                        flexGrow: 1,
                        overflow: 'auto', // enable vertical scroll
                        minHeight: 0,
                        maxHeight: '100%', // or set a custom height if needed
                    }}>


                        <div style={{ flexGrow: 1, ...(isDisabled ? disabledStyle : {}) }}>
                            <QueryBuilder
                                fields={fields}
                                operators={operatorOptions}
                                combinators={combinators}
                                controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
                                controlElements={{
                                    combinatorSelector: ({ handleOnChange, value }) => (  // NOSONAR
                                        <Select
                                            value={value}
                                            onChange={(e) => handleOnChange(e.target.value)}
                                            size="small"
                                            style={{ height: 30, overflow: 'visible' }}
                                            label='Combinator'

                                            sx={{ fontSize: '13px' }}
                                        >
                                            {combinators.length > 0 ? (
                                                combinators.map((combinator) => (
                                                    <MenuItem key={combinator.name} value={combinator.name} sx={{ fontSize: '13px' }}>
                                                        {combinator.label}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled sx={{ fontSize: '13px' }}>
                                                    No Options
                                                </MenuItem>
                                            )}
                                        </Select>
                                    ),
                                    fieldSelector: ({ handleOnChange, value, path, schema }) => {  // NOSONAR



                                        // Traverse using query
                                        let parent = initialQueryRef.current;
                                        // eslint-disable-next-line no-plusplus
                                        for (let i = 0; i < path.length - 1; i++) {
                                            parent = parent.rules[path[i]];
                                        }

                                        const siblingFieldNames = parent.rules?.map(item => item?.field);

                                        return (
                                            <FormControl sx={{ width: '45%' }} size='small'>

                                                <Autocomplete
                                                    value={value}
                                                    onChange={(event, newValue) => {
                                                        handleOnChange(newValue);
                                                        // Update selectedClassification when field changes
                                                        const selectedField = fields.find(f => f.name === newValue);
                                                        setSelectedClassification(selectedField ? selectedField.label : null);
                                                    }}
                                                    getOptionDisabled={option => siblingFieldNames.includes(option)}
                                                    options={fields?.map((field) => field.name) || []}
                                                    getOptionLabel={(option) => fields?.find(f => f.name === option)?.label || ''}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}

                                                            size="small"
                                                            fullWidth
                                                            sx={{
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '13px',  // Set text size to 13px
                                                                },
                                                                '& .MuiFormLabel-root': {
                                                                    fontSize: '14px',  // Set label text size to 14px
                                                                },
                                                            }}
                                                        />
                                                    )}

                                                    ListboxProps={{
                                                        style: {
                                                            maxHeight: '224px',
                                                            '& .MuiAutocomplete-option': {
                                                                fontSize: '13px',  // Set the font size for the options
                                                            },
                                                        },
                                                    }}
                                                    disableClearable
                                                    renderOption={(props, option) => (
                                                        <li
                                                            {...props}
                                                            style={{ fontSize: '13px' }} // Set font size for dropdown options
                                                        >
                                                            {fields.find(f => f.name === option)?.label || option}
                                                        </li>
                                                    )}
                                                    noOptionsText="No Options"
                                                />
                                            </FormControl>
                                        )
                                    },
                                    operatorSelector: ({ handleOnChange, value }) => (  // NOSONAR
                                        <FormControl style={{ width: '250px' }}>

                                            <Autocomplete
                                                value={value}
                                                onChange={(event, newValue) => handleOnChange(newValue)}
                                                options={operatorOptions.map((op) => op.name)}
                                                getOptionLabel={(option) => operatorOptions.find(op => op.name === option)?.label || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        fullWidth
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',  // Set text size to 13px
                                                            },
                                                            '& .MuiFormLabel-root': {
                                                                fontSize: '14px',  // Set label text size to 14px
                                                            },
                                                        }}
                                                    />
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '224px',
                                                        '& .MuiAutocomplete-option': {
                                                            fontSize: '13px',  // Set the font size for the options
                                                        },
                                                    },
                                                }}
                                                noOptionsText="No Options"
                                                disableClearable
                                            />
                                        </FormControl>
                                    ),
                                    // Inside the QueryBuilder control elements

                                    valueEditor: ItemValueEditor,





                                    addRuleAction: ({ handleOnClick, rules }) => {  // NOSONAR
                                        const usedFields = getUsedFieldsInGroup(rules);
                                        const allFieldsUsed = Array.isArray(fields) && fields.length > 0
                                            ? fields.every(f => usedFields.has(f.name))
                                            : false;

                                        return (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleOnClick}
                                                style={{ marginRight: 8, height: '25px', padding: '5px' }}
                                                size="small"
                                                disabled={allFieldsUsed}
                                            >
                                                Add Rule
                                            </Button>
                                        );
                                    },
                                    addGroupAction: ({ handleOnClick }) => (   // NOSONAR
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleOnClick}
                                            style={{ marginRight: 8, height: '25px', padding: '5px' }}
                                            size="small"
                                        >
                                            Add RuleSet
                                        </Button>
                                    ),
                                    removeRuleAction: ({ handleOnClick }) => (  // NOSONAR
                                        <IconButton onClick={handleOnClick} size="small">
                                            <ClearIcon sx={{ color: 'red', height: '16px', width: '16px' }} />
                                        </IconButton>
                                    ),
                                    removeGroupAction: ({ handleOnClick }) => (   // NOSONAR
                                        <IconButton onClick={handleOnClick} size="small">
                                            <ClearIcon sx={{ color: 'red', height: '16px', width: '16px' }} />
                                        </IconButton>
                                    ),
                                }}
                                query={initialQuery}
                                onAddRule={onAddRule}
                                onQueryChange={handleQueryChange}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '20px' }} >
                            {
                                schemeData?.AdditionalRebate && (
                                    <div >
                                        <Button variant="contained" onClick={handleAdditionalRebate} style={{ height: '35px', padding: '5px 10px 5px 10px' }}>
                                            + Contribution Item
                                        </Button>
                                    </div>
                                )
                            }

                            {
                                isContributionItemsVisible && (
                                    <Autocomplete
                                        multiple
                                        options={contributionItems}
                                        disableCloseOnSelect
                                        disableClearable
                                        size='small'
                                        getOptionLabel={(option) => option.Item}
                                        onInputChange={handleInputChange}
                                        inputValue={inputValue}
                                        renderInput={(params) => (

                                            <Tooltip
                                                id="tooltip-title-id"
                                                title={
                                                    <div
                                                        style={{
                                                            maxHeight: '150px',
                                                            overflowY: selectedContributionItems?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: '#9e9e9e',
                                                                fontSize: '12px',
                                                                fontWeight: '300',
                                                            }}
                                                        >
                                                            {selectedContributionItems?.map(item => item?.Item).join(', ')}
                                                        </span>
                                                    </div>
                                                }
                                                arrow
                                                placement="top"
                                                PopperProps={{
                                                    sx: {
                                                        '& .MuiTooltip-tooltip': {
                                                            backgroundColor: 'white', // White background
                                                            color: 'black', // Black text
                                                            border: '1px solid #ccc', // Optional: subtle border for better visibility
                                                            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                        },
                                                        '& .MuiTooltip-arrow': {
                                                            color: '#f9f9f9', // Match the arrow color with the tooltip background
                                                        },
                                                        display: selectedContributionItems?.length === 0 || selectedContributionItems === undefined || selectedContributionItems === null ? 'none' : '', // Fix conditional syntax
                                                    },
                                                }}
                                            >
                                                <TextField
                                                    style={{ fontSize: '13px' }}
                                                    {...params}
                                                    label={<span>Contribution Item <span style={{ color: 'red' }}>*</span></span>}
                                                    onChange={(e) => setSearchedValue(e.target.value)}
                                                    // placeholder={selectedContributionItems.length === 0 ? "Contribution Item" : ""}  // Conditionally hide placeholder
                                                    size='small'

                                                    sx={{
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '13px',  // Set text size to 13px
                                                        },
                                                        '& .MuiFormLabel-root': {
                                                            fontSize: '14px',  // Set label text size to 14px
                                                        },
                                                    }}

                                                />
                                            </Tooltip>
                                        )}
                                        renderTags={(selected) => {
                                            const selectedCount = selected.length;
                                            return (
                                                <span style={{ paddingLeft: '8px', fontSize: '13px' }}>
                                                    {selectedCount === 1
                                                        ? `${selectedCount} item selected`
                                                        : `${selectedCount} items selected`}
                                                </span>
                                            );
                                        }}
                                        PaperComponent={custom}
                                        slots={{
                                            paper: custom,
                                        }}
                                        slotProps={{
                                            paper: {
                                                contributionItems,
                                                inputValue,
                                                selectedContributionItems,
                                                setSelectedContributionItems,
                                            },
                                        }}


                                        renderOption={(props, option, { selected }) => (
                                            <li {...props} key={option?.ItemId || option} style={{ fontSize: '13px' }}>
                                                <Checkbox
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                    size='small'
                                                />
                                                {option.Item}
                                            </li>
                                        )}
                                        value={selectedContributionItems}
                                        onChange={(event, newValue) => {
                                            setSelectedContributionItems(newValue);
                                            setInputValue('');
                                        }}
                                        sx={{ width: '350px', maxHeight: '35.69px' }}

                                    />
                                )
                            }
                        </div>

                    </div>

                    {/* Divider */}
                    <Divider sx={{ mt: 2 }} />

                    {/* Save button fixed at the bottom */}
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        {
                            errorMessage && (
                                <span style={{ color: 'red', fontSize: '10px', marginRight: '1rem' }}>{errorMessage}</span>
                            )
                        }
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={2}
                            alignItems="center"
                            sx={{ padding: '2px' }}
                        >
                            {schemeDetails?.SchemeLock !== true && canSaveScheme && (
                                <Tooltip title="Save">
                                    <IconButton type="button" onClick={() => saveData()} sx={{
                                        bgcolor: '#43b5a2',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '31px',
                                        padding: '4px',
                                    }}>
                                        <Iconify icon="bx:save" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    </Box>


                    {(initialLoading.current || loadingCount > 0) && <LoadingProgressBar />}


                </div>

            </FormProvider>
        </div>


    );
};

export default SchemeItem
